import { ReactNode } from "react";

import { cn } from "@/common/utils/css.utils";
import { RadioButton } from "@/ui/cva/radio-button/RadioButton";

type SelectableCardProps = {
  /** Radio group name; cards sharing a name are mutually exclusive. */
  name: string;
  selected?: boolean;
  onSelect?: () => void;
  /** Left-hand title on the header row. */
  title: ReactNode;
  /** Right-hand content on the header row (price or "Free" badge). */
  trailing?: ReactNode;
  /** Body content rendered under the header row. */
  children?: ReactNode;
  className?: string;
};

/**
 * A radio-selectable bordered card, the shared shell behind the listing-fee and
 * boost options. The whole card is a label, so clicking anywhere selects it.
 */
export const SelectableCard = ({
  name,
  selected,
  onSelect,
  title,
  trailing,
  children,
  className,
}: SelectableCardProps) => {
  return (
    <label
      className={cn(
        "block cursor-pointer rounded-lg border bg-white p-4 shadow-lg shadow-grey-100 transition-colors",
        selected ? "border-brand-500" : "border-grey-200 hover:border-grey-300",
        className
      )}
    >
      <div className="flex items-center gap-3">
        <RadioButton
          name={name}
          checked={!!selected}
          onChange={() => onSelect?.()}
          className="shrink-0"
        />
        <span className="flex-1 font-title font-bold">{title}</span>
        {trailing && <span className="ml-auto shrink-0">{trailing}</span>}
      </div>
      {children}
    </label>
  );
};
